import { getLocalStorage } from 'neurons';

const getEmailSubscribed = (): boolean => {
    const subscriptionLocalStorage = getLocalStorage('show_sbscrptn_vkplay');

    return subscriptionLocalStorage === '0' || subscriptionLocalStorage === 'true';
};

export default getEmailSubscribed;
